import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=1fd4206e&"
import script from "./announcement.js?vue&type=script&lang=js&"
export * from "./announcement.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports